export const EMPTY_VALUE_DASH = '—';
